/* global FormData, Blob */
import { apiKey } from '../constants';
import { get } from '../utils/storage';

export default function prepareBody(body) {
    const form = new FormData();
    form.append('api_key', apiKey);
    const sessionKey = get('sessionKey');
    form.append('Session_Key', sessionKey);
    Object.keys(body).forEach((key) => {
        const value = body[key];
        if (value instanceof Blob) {
            const mime = value.type;
            let type;
            let name;
            switch (mime) {
                case 'image/jpeg':
                    type = '.jpg';
                    break;
                case 'image/gif':
                    type = '.gif';
                    break;
                case 'image/png':
                    type = '.png';
                    break;
                case 'image/svg+xml':
                    type = '.svg';
                    break;
                case 'image/webp':
                    type = '.webp';
                    break;
                default:
            }
            if (type) {
                name = `image${type}`;
            }

            form.append(key, value, name);
        } else {
            form.append(key, value);
        }
    });
    return form;
}



/** WEBPACK FOOTER **
 ** ./src/utils/prepareBody.js
 **/